export default {
	date_range_selection_days_label: 'days',
	date_selection_disabled_only_in_mine_or_all_tooltip: 'Only available in the "Mine" or "All" tab',
	date_selection_next_range_tooltip: 'Next range',
	date_selection_open_calendar_tooltip: 'Open calendar',
	date_selection_previous_range_tooltip: 'Previous range',
	date_selection_today_button_label: 'Today',
	direction_filter_combined: 'Combined',
	direction_filter_in: 'In',
	direction_filter_out: 'Out',
	empty_state_action_adjust_timerange: 'Adjust period',
	empty_state_action_clear_favorites: 'Clear favorites',
	empty_state_action_clear_search: 'Clear search',
	empty_state_action_open_filter: 'Open filter',
	empty_state_action_retry: 'Try again',
	empty_state_action_show_all: 'Show all',
	empty_state_desc_error: 'The list could not be loaded.',
	empty_state_desc_filter_unselected: 'Select modules or users to see their entries here.',
	empty_state_desc_filtered_favorite: 'Adjust your favorites or clear them.',
	empty_state_desc_filtered_search: 'Try a different search term.',
	empty_state_desc_scope: 'Nothing matches the current selection.',
	empty_state_desc_search_term_too_short: 'The mail search requires at least {minimumLength} characters.',
	empty_state_noun_agenda: 'appointments',
	empty_state_noun_document: 'documents',
	empty_state_noun_inbox: 'entries',
	empty_state_noun_mail: 'mails',
	empty_state_noun_message: 'messages',
	empty_state_noun_note: 'notes',
	empty_state_noun_notebook: 'folders',
	empty_state_noun_phone_call: 'phone calls',
	empty_state_noun_task: 'tasks',
	empty_state_noun_trash: 'items',
	empty_state_title_agenda: 'No appointments',
	empty_state_title_document: 'No documents',
	empty_state_title_error: 'Something went wrong',
	empty_state_title_filter_unselected: 'No modules selected yet',
	empty_state_title_filtered_favorite: 'No matches with active favorites',
	empty_state_title_filtered_search: 'No results for "{term}"',
	empty_state_title_inbox: 'No entries',
	empty_state_title_mail: 'No mails',
	empty_state_title_message: 'No messages',
	empty_state_title_note: 'No notes',
	empty_state_title_notebook: 'No folders',
	empty_state_title_phone_call: 'No phone calls',
	empty_state_title_scope_mine: 'None of your {noun}',
	empty_state_title_scope_open: 'No open {noun}',
	empty_state_title_scope_timeframe: 'No {noun} in this period',
	empty_state_title_search_term_too_short: 'Search term too short',
	empty_state_title_task: 'No tasks',
	empty_state_title_trash: 'Trash is empty',
	generic_list_all_done: 'All done',
	generic_list_bulk_actions_menu_label: 'Actions',
	generic_list_bulk_selection_count: '{count} selected',
	generic_list_column_channel: 'Channel',
	generic_list_column_contact: 'Contact',
	generic_list_column_info_modul: 'Module information',
	generic_list_column_information: 'Information',
	generic_list_column_order_description: 'Which columns should be displayed in the compact view, and in what order?',
	generic_list_column_timestamp: 'Time',
	generic_list_context_menu_add_to_existing_task: 'Add to existing task',
	generic_list_context_menu_create_and_link_ido: 'Create dataset',
	generic_list_context_menu_create_ido_in_last_used_instance: 'Create {instanceName}',
	generic_list_context_menu_create_task: 'Create task',
	generic_list_context_menu_download_documents_as_zip: 'Download as ZIP',
	generic_list_context_menu_ido_frequently_used_instances: 'Frequently used',
	generic_list_context_menu_ido_infrequently_used_instances: 'Infrequently used',
	generic_list_context_menu_ido_last_used_instance: 'Last used: {instanceName}',
	generic_list_context_menu_ido_loading_instances: 'Loading instances...',
	generic_list_context_menu_ido_no_instances: 'No instances available',
	generic_list_context_menu_link_existing_ido: 'Add link',
	generic_list_context_menu_remove_from_folder: 'Remove from folder',
	generic_list_context_menu_remove_from_folder_success: 'The item was removed from the folder',
	generic_list_context_menu_search_contact_history: 'Contact history',
	generic_list_context_menu_send_document_via_mail: 'Send via mail',
	generic_list_context_menu_sheet_selected_count: '{count} selected',
	generic_list_default_clear_action: 'Reset default',
	generic_list_default_clear_confirm_accept: 'Reset',
	generic_list_default_clear_confirm_header: 'Reset default view?',
	generic_list_default_clear_confirm_message:
		'The saved default view for this module will be removed. Your current view stays as it is, but no default will be applied the next time you switch modules.',
	generic_list_default_clear_success: 'Default view has been reset.',
	generic_list_default_load_action: 'Load default view',
	generic_list_default_save_as_action: 'Save this view as default',
	generic_list_default_save_confirm_accept: 'Save',
	generic_list_default_save_confirm_header: 'Save as default?',
	generic_list_default_save_confirm_message_new:
		'The current view will be saved as the default for this module and applied automatically the next time you switch modules.',
	generic_list_default_save_confirm_message_overwrite:
		'The existing default for this module will be overwritten. The current view will be saved as the new default.',
	generic_list_default_save_success: 'Default view for this module has been saved.',
	generic_list_export_confirm_accept: 'Export',
	generic_list_export_confirm_header: 'Export all entries',
	generic_list_export_confirm_message: '{count} entries will be exported. Do you want to continue?',
	generic_list_export_csv: 'Export as CSV',
	generic_list_export_error: 'The export failed.',
	generic_list_export_html: 'Export as HTML',
	generic_list_export_pdf_landscape: 'Export as PDF landscape',
	generic_list_export_pdf_portrait: 'Export as PDF portrait',
	generic_list_export_phase_building: 'Creating file…',
	generic_list_export_phase_loading: 'Loading {count} entries…',
	generic_list_export_success: 'The export has been downloaded.',
	generic_list_export_timeout: 'The export took too long. Please try again.',
	generic_list_export_tooltip: 'Export',
	generic_list_export_tsv: 'Export as TSV',
	generic_list_export_xlsx: 'Export as XLSX',
	generic_list_filter_toggle_tooltip: 'Toggle filter',
	generic_list_grouped_status_archived: 'Archived',
	generic_list_grouped_status_button_aria_label: 'Show participant status',
	generic_list_grouped_status_button_tooltip: 'Show participant status',
	generic_list_grouped_status_delegated: 'Shared',
	generic_list_grouped_status_direct: 'Direct',
	generic_list_jump_to_top: 'Back to top',
	generic_list_large_list_layout_tooltip: 'Toggle layout',
	generic_list_loading: 'Loading…',
	generic_list_loading_more_progress: 'Loading {from}–{to} of {total}',
	generic_list_multi_actions: 'Actions',
	generic_list_multi_select_checkbox_aria_label: 'Select entry',
	generic_list_multi_select_tooltip: 'Multi-selection',
	generic_list_searching_for: 'Searching for "{term}"…',
	generic_list_select_all_header_tooltip: 'Select all / clear selection',
	generic_list_select_all_in_group_tooltip: 'Select all in this group',
	generic_list_shared_query_clear_selection: 'Clear list selection',
	generic_list_shared_query_group_actions: 'Actions',
	generic_list_shared_query_group_lists: 'Saved lists',
	generic_list_shared_query_menu_tooltip: 'Open the list menu',
	generic_list_shared_query_save_as_action: 'Save as list',
	generic_list_shared_query_save_as_context:
		'The search, filters, time range and sorting of this list are saved with it.',
	generic_list_shared_query_save_as_dialog_title: 'Save list as',
	generic_list_shared_query_save_as_field_label: 'List name',
	generic_list_shared_query_save_as_name_placeholder: 'e.g. Open tasks – Sales',
	generic_list_shared_query_save_button: 'Save',
	generic_list_shared_query_save_error: 'The list could not be saved.',
	generic_list_shared_query_save_success: 'The list "{name}" has been saved.',
	generic_list_shared_query_save_unsupported_time_range: 'This time range cannot be saved as a legacy list.',
	generic_list_sort_by: 'Sort by',
	generic_list_sort_order: 'Sort order',
	generic_list_sort_order_a_to_z: 'A to Z',
	generic_list_sort_order_ascending: 'Ascending',
	generic_list_sort_order_descending: 'Descending',
	generic_list_sort_order_newest_first: 'Newest first',
	generic_list_sort_order_oldest_first: 'Oldest first',
	generic_list_sort_order_z_to_a: 'Z to A',
	generic_list_sort_property_channel: 'Channel',
	generic_list_sort_property_date_time: 'Time',
	generic_list_sort_property_information: 'Information',
	generic_list_sort_tooltip: 'Sort',
	generic_list_status_change_is_being_performed: 'Change of status is performed...',
	generic_list_viewed_user_mine: 'My start page',
	generic_list_viewed_user_select_sheet_title: "User's start page",
	grouping_module_label_activity: 'Memos',
	grouping_module_label_appointment: 'Appointments',
	grouping_module_label_document: 'Documents',
	grouping_module_label_mail: 'Mails',
	grouping_module_label_message: 'Messages',
	grouping_module_label_note: 'Notes',
	grouping_module_label_phoneCall: 'Phone calls',
	grouping_module_label_scheduled_activity: 'Scheduled Activities',
	grouping_module_label_task: 'Tasks',
	grouping_timeframe_label_lastMonth: 'Last month',
	grouping_timeframe_label_lastWeek: 'Last week',
	grouping_timeframe_label_next_month: 'Next month',
	grouping_timeframe_label_next_week: 'Next week',
	grouping_timeframe_label_next_year: 'Next year',
	grouping_timeframe_label_olderThanAMonth: 'More than a month ago',
	grouping_timeframe_label_this_year: 'This year',
	grouping_timeframe_label_thisMonth: 'This month',
	grouping_timeframe_label_thisWeek: 'This week',
	grouping_timeframe_label_today: 'Today',
	grouping_timeframe_label_tomorrow: 'Tomorrow',
	grouping_timeframe_label_yesterday: 'Yesterday',
	inbox_footer_options_reset: 'Reset',
	inbox_footer_options_sheet_title: 'Start page view',
	inbox_footer_options_shortcuts_section: 'Shortcuts',
	inbox_footer_options_start_page_section: 'Start page',
	mini_calendar_last_four_weeks_label: 'The last four weeks',
	mini_calendar_last_month_label: 'Last month',
	mini_calendar_last_week_label: 'Last week',
	mini_calendar_mode_day_label: 'Day',
	mini_calendar_mode_range_label: 'Range',
	mini_calendar_this_month_label: 'This month',
	mini_calendar_this_week_label: 'This week',
	mini_calendar_today_label: 'Today',
	mini_calendar_yesterday_label: 'Yesterday',
	module_chip_label_activity: 'Memo',
	module_chip_label_appointment: 'Appointment',
	module_chip_label_document: 'Document',
	module_chip_label_mail: 'Mail',
	module_chip_label_message: 'Message',
	module_chip_label_note: 'Note',
	module_chip_label_phoneCall: 'Phone call',
	module_chip_label_scheduled_activity: 'Scheduled Activity',
	module_chip_label_task: 'Task',
	multi_action_confirm_label: 'Yes',
	multi_action_delete_dialog_title: 'Confirm delete',
	multi_action_delete_question: 'Do you really want to delete all selected items?',
	multi_action_discard_label: 'No',
	multi_action_label_appointment: 'Appointments',
	multi_action_label_document: 'Documents',
	multi_action_label_mail: 'Mails',
	multi_action_label_message: 'Messages',
	multi_action_label_note: 'Notes',
	multi_action_label_phoneCall: 'Phone calls',
	multi_action_label_scheduled_activity: 'File note',
	multi_action_label_task: 'Tasks',
	multi_action_publish_change_dialog_title: 'Confirm publish change',
	multi_action_publish_change_question_publish: 'Do you really want to publish all selected items?',
	multi_action_publish_change_question_un_publish: 'Do you really want to hide all selected items?',
	multi_action_restore_dialog_title: 'Confirm restore',
	multi_action_restore_question: 'Do you really want to restore all selected items?',
	multi_action_selection_count_module_activity_label_multiple: 'Memos',
	multi_action_selection_count_module_activity_label_single: 'Memo',
	multi_action_selection_count_module_appointment_label_multiple: 'Appointment',
	multi_action_selection_count_module_appointment_label_single: 'Appointment',
	multi_action_selection_count_module_document_label_multiple: 'Documents',
	multi_action_selection_count_module_document_label_single: 'Document',
	multi_action_selection_count_module_mail_label_multiple: 'Mails',
	multi_action_selection_count_module_message_label_multiple: 'Messages',
	multi_action_selection_count_module_message_label_single: 'Message',
	multi_action_selection_count_module_note_label_multiple: 'Notepad',
	multi_action_selection_count_module_note_label_single: 'Notepad',
	multi_action_selection_count_module_phoneCall_label_multiple: 'Call',
	multi_action_selection_count_module_phoneCall_label_single: 'Call',
	multi_action_selection_count_module_task_label_multiple: 'Tasks',
	multi_action_selection_count_module_task_label_single: 'Task',
	multi_action_selection_header: 'Selection',
	multi_action_selection_module_count_module_mail_label_single: 'Mail',
	multi_action_spam_dialog_title: 'Confirm spam',
	multi_action_spam_question: 'Do you really want to spam all selected items?',
	multi_action_state_change_dialog_title: 'Confirm state change',
	multi_action_state_change_question_prefix: 'Do you really want to mark all selected items as',
	multi_action_state_change_question_suffix: '?',
	multi_action_task_scheduling_dialog_title: 'Confirm task scheduling',
	multi_action_task_scheduling_dialog_title_next_week: 'Delay tasks to next week',
	multi_action_task_scheduling_dialog_title_specific_date: 'Schedule tasks to specific date',
	multi_action_task_scheduling_dialog_title_tomorrow: 'Delay tasks to tomorrow',
	multi_action_task_scheduling_question: 'Do you really want to schedule all selected tasks?',
	multi_action_task_scheduling_question_next_week: 'Do you really want to delay all selected tasks to next week?',
	multi_action_task_scheduling_question_specific_date:
		'Do you really want to schedule all selected tasks to the selected date?',
	multi_action_task_scheduling_question_tomorrow: 'Do you really want to delay all selected tasks to tomorrow?',
	multi_document_zip_confirm_cancel_label: 'Cancel',
	multi_document_zip_confirm_message: 'This will load {count} documents and package them into a ZIP file. Continue?',
	multi_document_zip_confirm_ok_label: 'Download',
	multi_document_zip_confirm_title: 'Download as ZIP',
	multi_document_zip_failed: 'The ZIP download failed',
	multi_document_zip_packaging: 'Creating ZIP file…',
	multi_document_zip_progress: 'Loading document {current} of {total}…',
	multi_document_zip_success: 'Downloaded ZIP file with {count} documents',
	multi_task_next_week: 'Delay to Next Week',
	multi_task_next_week_notification: 'Tasks delayed to next week',
	multi_task_schedule_to_date: 'Schedule to Date...',
	multi_task_scheduled_notification: 'Tasks scheduled to {date}',
	multi_task_tomorrow: 'Delay to Tomorrow',
	multi_task_tomorrow_notification: 'Tasks delayed to tomorrow',
	multiple_action_label_scheduled_activity: 'Scheduled activities',
	select_date_hint: 'Only today and future dates can be selected',
	select_date_label: 'Select Date',
	task_schedule_to_date: 'Schedule to Date...',
	task_scheduled_notification: 'Task scheduled to {date}',
};
